var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright"},[_vm._v(" 版权所有：中智薪税技术服务有限公司 "),_c('br'),_vm._v(" 京公网安备11010502042147号 京ICP备07500522号 ")])}]

export { render, staticRenderFns }